import script from "./CreateDisease.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateDisease.vue?vue&type=script&setup=true&lang=js"

import "./CreateDisease.vue?vue&type=style&index=0&id=02ac451e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ac451e"]])

export default __exports__